var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.skin, _vm._b({
    tag: "component",
    on: {
      "input": _vm.input,
      "next": _vm.next
    },
    model: {
      value: _vm.user,
      callback: function callback($$v) {
        _vm.user = $$v;
      },
      expression: "user"
    }
  }, 'component', _vm.$attrs, false));
}
var staticRenderFns = []

export { render, staticRenderFns }